import React from "react";
import dayjs from "dayjs";
import "dayjs/locale/vi";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { commonFieldSx } from "./dropdownStyles";

export default function AppDatePicker({
  label,
  value,
  onChange,
  disabled = false,
  fullWidth = true,
  sx,
  format = "DD/MM/YYYY",
  outputFormat = "YYYY-MM-DD",
  ...props
}) {
  const dateValue = value ? dayjs(value) : null;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="vi">
      <DatePicker
        {...props}
        label={label}
        value={dateValue?.isValid() ? dateValue : null}
        onChange={(nextValue) => {
          onChange?.(nextValue?.isValid?.() ? nextValue.format(outputFormat) : "", nextValue);
        }}
        format={format}
        disabled={disabled}
        slotProps={{
          textField: {
            fullWidth,
            size: "small",
            sx: {
              ...commonFieldSx,
              ...sx,
            },
          },
        }}
      />
    </LocalizationProvider>
  );
}